import { render, staticRenderFns } from "./ScreenVertical.vue?vue&type=template&id=70008300&scoped=true"
import script from "./ScreenVertical.vue?vue&type=script&lang=js"
export * from "./ScreenVertical.vue?vue&type=script&lang=js"
import style0 from "./ScreenVertical.vue?vue&type=style&index=0&id=70008300&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70008300",
  null
  
)

export default component.exports